import { FilterValue } from '@src/design-system/filter-new';
import type { TRenderSelectedValuesCtx } from '../../types/filter-config';
import labelApi from '@src/shared/components/reusables/labels/services/label-api';
import { entityFilterIds } from '../../helpers/filter-none';

const SingleValue = ({ id }: { id: string | number }) => {
  const { data: label } = labelApi.useFetchOne({ id });

  return (
    <FilterValue style={{ background: label?.hexa_color }}>
      {label?.name}
    </FilterValue>
  );
};

export function LabelFilterSelectedValues({
  filter,
}: TRenderSelectedValuesCtx) {
  return entityFilterIds(filter.value).map((v) => (
    <SingleValue
      key={v}
      id={v}
    />
  ));
}
